import { Api, buildQueryString } from '@/common/utils';

export const getAdminDecedents = (params) =>
  Api.request({
    url: `/decedent/list${buildQueryString(params)}`,
  });
